import React from "react";
import dayjs from "dayjs";

import { Box, IconButton } from "@material-ui/core";
import ChevronLeft from "mdi-material-ui/ChevronLeft";
import ChevronRight from "mdi-material-ui/ChevronRight";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import rem from "../utils/rem";
import { withStyles } from "@material-ui/core/styles";

const DateInput = styled.input`
  text-align: center;
  line-height: ${rem(16)};
  border-radius: ${rem(4)};
  border: 1px solid #aeaeae;
  font-size: ${rem(13)};
  padding: ${rem(6)} 0 ${rem(6)} 0;
  cursor: pointer;
`;

const styles = theme => ({
  datePickerWrapper: {
    width: "fit-content"
  }
});

class Calendar extends React.Component {
  render() {
    const { setDate, date, classes } = this.props;

    const handleSubtractDay = () => {
      setDate(
        dayjs(date)
          .subtract(1, "day")
          .toDate()
      );
    };

    const handleAddDay = () => {
      setDate(
        dayjs(date)
          .add(1, "day")
          .toDate()
      );
    };

    return (
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.25rem"
        }}
      >
        <IconButton onClick={() => handleSubtractDay()} size="small">
          <ChevronLeft />
        </IconButton>
        <DatePicker
          selected={date}
          onChange={date => setDate(date)}
          customInput={<DateInput />}
          wrapperClassName={classes.datePickerWrapper}
        />
        <IconButton onClick={() => handleAddDay()} size="small">
          <ChevronRight />
        </IconButton>
      </Box>
    );
  }
}

export default withStyles(styles)(Calendar);



// WEBPACK FOOTER //
// ./src/components/Calendar.js